// レイヤースタイルの適用順序 (下 → 上)。ここが唯一の定義。
// Photoshop: ドロップシャドウ → 光彩 (外側) → 境界線 (外側) → 本体 → シャドウ (内側) → 光彩 (内側) →
// ベベル → サテン → カラーオーバーレイ → グラデーションオーバーレイ → 境界線 (内側/中央)

import type { LayerStyle } from '@/types/document'

export type EffectId = 'dropShadow' | 'outerGlow' | 'strokeOutside' | 'body' | 'innerShadow' | 'innerGlow' | 'bevel' | 'satin' | 'colorOverlay' | 'gradientOverlay' | 'patternOverlay' | 'strokeInside'

export const EFFECT_ORDER: EffectId[] = ['dropShadow', 'outerGlow', 'strokeOutside', 'body', 'innerShadow', 'innerGlow', 'bevel', 'satin', 'colorOverlay', 'gradientOverlay', 'patternOverlay', 'strokeInside']

/** 有効な効果があるか */
export function hasActiveStyles(s: LayerStyle | undefined): boolean {
  if (!s) return false
  return Object.values(s).some(fx => fx && (fx as { enabled: boolean }).enabled)
}

/** 効果がレイヤーの外側へはみ出す最大距離 (px)。ダーティ矩形の余白に使う */
export function styleExtent(s: LayerStyle | undefined): number {
  if (!s) return 0
  let ext = 0
  if (s.dropShadow?.enabled) ext = Math.max(ext, s.dropShadow.distance + s.dropShadow.size * 2 + 1)
  if (s.outerGlow?.enabled) ext = Math.max(ext, s.outerGlow.size * 2 + 1)
  if (s.stroke?.enabled && s.stroke.position !== 'inside') ext = Math.max(ext, s.stroke.size + 1)
  if (s.bevel?.enabled && s.bevel.style !== 'inner') ext = Math.max(ext, s.bevel.size * 2 + 1)
  return Math.ceil(ext)
}
